import { useTranslation } from 'react-i18next';
import { TeContainer, TeContainerSlim, TeText } from '@topcon/tuicl-react';

import DealerSelector from '../../../components/ServiceAgreement/Dealers/DealerSelector';
import { AvailableAgreementsFilters } from './dealers.queries';
import { BusinessPartnerBody } from '../../../api/generated/pm';

function SelectDealerStep({
  filters,
  onFiltersChange,
  providers,
  loading,
  onSelect,
  selectedDealer,
}: {
  filters: AvailableAgreementsFilters;
  onFiltersChange: (update: Partial<AvailableAgreementsFilters>) => void;
  providers: BusinessPartnerBody[] | undefined;
  loading: boolean;
  onSelect: (bp: BusinessPartnerBody) => void;
  selectedDealer: BusinessPartnerBody | undefined;
}) {
  const { t } = useTranslation();

  return (
    <TeContainer
      column
      grow
      backgroundColor="background.secondary"
      justifyContent="center"
      borderRadius="l"
      padding="s"
      data-testid="modal-step-2"
    >
      <TeContainerSlim fill grow column justifyContent="center" gap="xs">
        <TeText weight={700} size={16}>
          {t('dealers.createModal.title')}
        </TeText>
        <TeText weight={400} size={12} color="text.secondary">
          {t('dealers.createModal.subtitle')}
        </TeText>
      </TeContainerSlim>
      <DealerSelector
        filters={filters}
        onFiltersChange={onFiltersChange}
        providers={providers}
        loading={loading}
        onSelect={onSelect}
        selectedDealer={selectedDealer}
      />
    </TeContainer>
  );
}

export default SelectDealerStep;
